import React, { useContext, useEffect, useState } from "react";
import { Table, Space, Tooltip } from "antd";
import { DeleteOutlined,EditOutlined } from "@ant-design/icons";
import DirectoryContext from "../../../context/directoryManagementContext";
import useAxiosInstance from "../../../lib/useAxiosInstance";
import DeleteModal from "../../DeleteModal";
import MapModal from "../MapModel";
import { EnvironmentOutlined } from "@ant-design/icons";

const { Column } = Table;

const PartyMemberTable = ({ membersData, handleDelete, searchResults,searchKeyword }) => {
  const directoryContext = useContext(DirectoryContext);
  const axiosInstance = useAxiosInstance();
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [mapLocation, setMapLocation] = useState({ lat: 0, lng: 0 });
  const [mapPlace, setMapPlace] = useState("");

  const openDeleteModal = (record) => {
    setSelectedRecord(record);
    setDeleteModal(true);
  };
  // console.log("Map place",mapPlace)

  // useEffect(() => {
  //   if (membersData?.length > 0) {
  //     // console.log("Members Data",mapLocation)
  //     const firstWithCoordinates = membersData.find(member => member.coordinates?.lat && member.coordinates?.lng);
  //     console.log("First with coor",firstWithCoordinates)
  //     if (firstWithCoordinates) {
  //       setMapLocation(firstWithCoordinates.coordinates);
  //     }
  //   }
  // }, [membersData]);


  const dataToShow = searchKeyword ? searchResults : membersData;

  // console.log("Data to show",dataToShow)

  const handleEdit = async (record) => {
    const response = await axiosInstance.get(`/api/directory/party-members/${record._id}`);
    directoryContext.updateEditData(response.data.data);
    directoryContext.updateAddMode(false);
    directoryContext.updateOpenModal(true);
  };
  

  return (
    <>
        <Table dataSource={dataToShow} rowKey="_id" pagination={false}>
        <Column title="Name" render={(text, record) => `${record.firstName} ${record.lastName}`} />
        <Column title="Position" dataIndex="position" />
        <Column title="Phone" dataIndex="phone" />
        {/* <Column title="Location" dataIndex="place" /> */}
        <Column
          title="Location"
          dataIndex="place"
          render={(place) => (
            <div className="flex items-center gap-2">
              {place}
              {/* {place && (
                <Tooltip title="View on Map">
                  <EnvironmentOutlined
                    style={{ color: "#1890ff", cursor: "pointer" }}
                    onClick={async () => {
                      // const coords = await geocodePlace(place);
                      // setMapLocation(coordinates);
                      setMapPlace(place);
                      setMapModalOpen(true);
                    }}
                  />
                </Tooltip>
              )} */}
            </div>
          )}
        />
        <Column 
          title="Map"
          dataIndex="coordinates"
          render={(coordinates,place) => (
            <div className="flex items-center gap-2">
              {coordinates && (
                <Tooltip title="View on Map">
                  <EnvironmentOutlined
                    style={{ color: "#1890ff", cursor: "pointer" }}
                    onClick={async () => {
                      // const coords = await geocodePlace(place);
                      setMapLocation(coordinates);
                      setMapPlace(place);
                      setMapModalOpen(true);
                    }}
                  />
                </Tooltip>
              )}
            </div>
          )}>
                    
        </Column>
        {/* <Column title="Address" dataIndex="address" /> */}
        <Column
          title="Action"
          key="action"
          render={(text, record) => (
            <Space>
              <Tooltip title="Edit">
                <button onClick={() => handleEdit(record)} className="p-2 text-xl text-blue-600 hover:bg-blue-100 rounded-full"><EditOutlined /></button>
              </Tooltip>
              <Tooltip title="Delete">
                <button onClick={() => openDeleteModal(record)} className="p-2 text-xl text-red-600 hover:bg-red-100 rounded-full"><DeleteOutlined /></button>
              </Tooltip>
            </Space>
          )}
        />
      </Table>
     { mapModalOpen && <MapModal
        visible={mapModalOpen}
        onClose={() => setMapModalOpen(false)}
        location={mapLocation}
        place={mapPlace?.place}
      />  }   
      {deleteModal && (
        <DeleteModal
          textheading="Party Contact"
          deleteTitle="Party Contact"
          deleteBtn="Delete Member"
          handleDelete={() => handleDelete(selectedRecord)}
          isDeleteModal={deleteModal}
          showModalDelete={() => setDeleteModal(false)}
        />
      )}
    </>
  );
};

export default PartyMemberTable;
